import { lazy } from 'react'
import { RouteObject } from 'react-router-dom'
import PartnerConsoleAccessGuard from './components/PartnerConsole/access-guard'

const ConvertWebp = lazy(() => import('./components/ConvertWebp'))
const PartnerConsole = lazy(() => import('./components/PartnerConsole'))

const ToolsModule: RouteObject = {
    path: 'tools',
    children: [
        {
            path: 'convert-webp',
            element: <ConvertWebp />,
        },
        {
            path: 'waf-free-report',
            element: (
                <PartnerConsoleAccessGuard>
                    <PartnerConsole />
                </PartnerConsoleAccessGuard>
            ),
        },
    ],
}

export default ToolsModule
